// Tiny className-merge helper used across redesign components.
// clsx handles conditionals; tailwind-merge dedupes conflicting Tailwind classes
// so consumer overrides win (e.g. <Button className="bg-coral" /> beats default).
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
